import classNames from 'classnames';
import React from 'react';

interface PropTypes {
  allowedFormats: string[];
  hideAllowedFormats?: boolean;
  maxFileSizeMb: number;
  maxFilesAttachment?: number;
  errors: any[];
  hideMaxSize?: boolean;
  customFooterText?: string;
}

export function AttachmentInputFooter(props: PropTypes) {
  const hideFormat = props.hideAllowedFormats;

  return (
    <div
      className={classNames('d-flex', 'flex-column', 'text-dark-200', 'mt-2')}
    >
      {props.errors.map((v, i) => (
        <small key={i} className='text-danger-500'>
          {v.message}
        </small>
      ))}
      {!hideFormat && (
        <div className='d-flex'>
          <small>
            {'Allowed file formats: ' + props.allowedFormats.join(', ')}
          </small>
          {!props.hideMaxSize && (
            <small className='ms-auto'>
              {`Max file size: ${props.maxFileSizeMb}MB`}
            </small>
          )}
          {props.customFooterText && (
            <small className='ms-auto'>{props.customFooterText}</small>
          )}
        </div>
      )}
    </div>
  );
}
